export default {
  'auth.error.generic': '操作失败，请稍后重试',
  'auth.error.captcha.tooFrequent': '验证码发送过于频繁，请稍后再试',
  'auth.error.captcha.dailyLimit': '验证码今日发送次数已达上限，请明日再试',
};
